import { Dimensions, StyleSheet } from 'react-native';
import colors from '@/config/colors';
import { IS_WEB } from '@/utils/platform';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    backgroundColor: '#f5f5f5',
  },
  sidebar: {
    backgroundColor: '#fff',
    borderRightWidth: 1,
    borderRightColor: '#ddd',
    // 88 is height of header
    height: IS_WEB ? Dimensions.get('window').height - 88 : '100%',
    paddingTop: 20,
    position: 'relative',
  },
  toggleButton: {
    padding: 12,
    alignItems: 'center',
    position: 'absolute',
    top: 20,
    left: 43,
  },
  menuItemContainer: {
    height: 48,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 8,
  },
  isSelected: {
    backgroundColor: colors.newUI.therapist.bgBlue10,
    borderLeftWidth: 8,
    borderColor: colors.newUI.therapist.green70,
    paddingLeft: 0,
  },
  menuLabel: {
    fontSize: 16,
    color: '#333',
  },
  mainContent: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  contentText: {
    fontSize: 18,
    color: '#333',
  },
  subMenuContainer: {
    position: 'absolute',
    left: '100%',
    top: 0,
    backgroundColor: colors.white,
    paddingVertical: 10,
    paddingHorizontal: 15,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    zIndex: 9999,
    elevation: 10,
  },
  subMenuItem: {
    paddingVertical: 8,
    fontSize: 16,
    color: colors.black,
  },
  subMenuWrapper: {
    position: 'absolute',
    bottom: 50,
    backgroundColor: colors.white,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 10,
    width: 250,
  },
  expandedMenuItemWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
});
